import { $tid } from '@provider-portal/common/utils/testIdConfig';

import { ProviderPortalApp } from './src/ProviderPortalApp';

// eslint-disable-next-line @typescript-eslint/no-require-imports
require('@bolteu/kalep-react/build/kalep-versioned.css');

const app = new ProviderPortalApp();
app.setup();

window.$tid = $tid;
